import React from 'react'
import { Eye, MessageCircle, Lock } from 'lucide-react'

const STEPS = [
  {
    icon: Eye,
    title: 'Notices when you drift',
    body:
      'Sees which tabs you switch to — not what you type. Knows the difference between a quick break and an hour lost on YouTube.',
  },
  {
    icon: MessageCircle,
    title: 'Nudges, not blocks',
    body:
      'A short message, framed the way a thoughtful friend would. You decide whether to come back. No shame, no hard walls.',
  },
  {
    icon: Lock,
    title: 'Private by design',
    body:
      'Runs in your browser. No accounts, no tracking pixels, and your browsing history never leaves your machine.',
  },
]

export function HowItWorks() {
  return (
    <section id="how-it-works" className="relative py-24 md:py-32 bg-white">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-20">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-8 bg-ink/15" />
            <span className="eyebrow">§ 01 — How it works</span>
            <span className="h-px w-8 bg-ink/15" />
          </div>
          <h2 className="font-display text-4xl md:text-5xl text-ink tracking-tightest leading-[1.05]">
            A copilot, <span className="italic">not a cop.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-x-10 gap-y-16">
          {STEPS.map(({ icon: Icon, title, body }, i) => (
            <div key={title} className="relative">
              <div className="font-display italic text-7xl text-brand/25 leading-none mb-5 select-none">
                {String(i + 1).padStart(2, '0')}
              </div>

              <div className="w-10 h-10 rounded-lg bg-paper border border-ink/10 flex items-center justify-center mb-5 text-brand">
                <Icon size={20} strokeWidth={1.75} />
              </div>

              <h3 className="font-display text-2xl md:text-[1.65rem] text-ink mb-3 leading-tight">
                {title}
              </h3>

              <p className="text-[15px] text-ink-mute leading-relaxed">
                {body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
